import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "./../store/index.js";
import { i18n } from "@/plugins/i18n";
import CryptoJS from "crypto-js";
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: `/${i18n.locale}`
  },
  {
    path: '/:lang',
    component: {
      render: h => h('router-view')
    },
    children: [
      {
        path: "/",
        component: function () {
          return import("../layouts/Default.vue");
        },

        beforeEnter: (to, from, next) => {
          if (!store.state.Auth.accToken) {
            let data = {
              acctoken: store.state.Auth.refeshToken,
              province: store.state.Auth.refeshProvince,
              store_id: store.state.Auth.refeshStoreID,
            };
            let encrypted = CryptoJS.AES.encrypt(
              JSON.stringify(data),
              process.env.VUE_APP_SECRET_KEY
            )
              .toString()
              .replace(/\+/g, "p1L2u3S")
              .replace(/\//g, "s1L2a3S4h")
              .replace(/=/g, "e1Q2u3A4l");

            next(
              `/${i18n.locale}` +
              "/verifying/" +
              encrypted
            );

          } else {
            next();
          }
        },
        children: [
          {
            path: "/",
            name: "homePage",
            component: function () {
              return import("../views/Home.vue");
            }
          },
          {
            path: "editstoreinformation",
            name: "editstoreinformation",
            component: function () {
              return import("../views/EditStoreInfo.vue");
            }
          },
          // {
          //   path: "staffmanage",
          //   name: "staffmanage",
          //   component: function () {
          //     return import("../views/User.vue");
          //   },
          //   beforeEnter: (to, from, next) => {
          //     if (
          //       store.state.Auth.userInfo.data_permission.us_user_role_id == 1
          //     ) {
          //       next();
          //     } else {
          //       next("/");
          //     }
          //   }
          // },
          {
            path: "product",
            name: "product",
            component: function () {
              return import("../views/Product.vue");
            }
          },
          {
            path: "order",
            name: "order",
            component: function () {
              return import("../views/Order.vue");
            }
          },
          {
            path: "reportdashboard",
            name: "reportdashboard",
            component: function () {
              return import("../views/ReportDashboard.vue");
            },
            beforeEnter: (to, from, next) => {
              if (
                store.state.Auth.userInfo.data_permission.us_user_role_id == 1 ||
                store.state.Auth.userInfo.data_permission.us_user_role_id == 2
              ) {
                next();
              } else {
                next("/");
              }
            }
          }
        ]
      },

    ]
  },
  {
    path: "/:lang/verifying/:encryptedString",
    name: "verifyingPage",
    component: function () {
      return import("../views/Loading.vue");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
  // : [
  //   {
  //     path: '/:lang',
  //     component: {
  //       render: h => h('router-view')
  //     },
  //     children: [
  //       {
  //         path: '',
  //         name: 'home',
  //         component: Home,
  //       }
  //     ]
  //   }
  // ]
});

export default router;
